import Url from 'url-parse';

export function repoToAction(repo) {
  const { pathname } = Url(repo);
  return `${pathname.replace('/', '')}@master`;
}
